import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import chatService from '../../services/chatService/ChatService';

/**
 * Opens the chat of a stay's booking (spec 016 W27). The server returns the inquiry chat the
 * guest already opened with this host about this place, or a new one, and the request note is
 * already its first message.
 */
export function useOpenBookingChat() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const open = async (booking: {
    id: string;
    guest?: { id: string } | null;
    host?: { id: string } | null;
  }) => {
    if (!booking.guest?.id || !booking.host?.id) {
      navigate('/chat');
      return;
    }
    setLoading(true);
    try {
      const chatId = await chatService.getOrCreateChat({
        bookingId: booking.id,
        guestId: booking.guest.id,
        hostId: booking.host.id,
      });
      navigate(`/chat/${chatId}`, { state: { bookingId: booking.id, stay: true } });
    } catch (e: any) {
      toast.error(e?.message || 'The chat could not be opened');
    } finally {
      setLoading(false);
    }
  };

  return { open, loading };
}
